import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ClientForm from "../components/Clients/ClientForm";
import ClientInfo from "../components/Clients/ClientInfo";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";
import ClientScopesGrid from "../components/Clients/ClientScopesGrid";

const ClientDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewClient = !id;

  const {data, loading, read, remove} = useApiRequest(`/clients`, !isNewClient);

  useEffect(() => {
    if (!isNewClient) {
      read(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [isEditing, setIsEditing] = useState(isNewClient);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este cliente?");
    if (confirmDelete) {
      try {
        await remove(id);
        navigate("/clients");
      } catch (error) {
        console.error("Error al eliminar el cliente:", error);
      }
    }
  };

  return (
    <Window title={isNewClient ? "Nuevo Cliente" : "Detalles del Cliente"}>
      <Stack spacing={2}>
        {loading && !isNewClient ? (
          <CircularProgress />
        ) : (
          <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
            {isEditing ? (
              <ClientForm
                isNew={isNewClient}
                refreshData={() => read(id)}
                setIsEditing={setIsEditing}
                initialClientData={data}
              />
            ) : (
              <ClientInfo client={data} />
            )}

            <Box>
              {!isNewClient &&
                (isEditing ? (
                  <Button variant="contained" color="primary" onClick={handleEditToggle}>
                    Cancelar
                  </Button>
                ) : (
                  <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                    <FiEdit2 />
                  </IconButton>
                ))}
              {!isNewClient && (
                <IconButton aria-label="delete" color="secondary" onClick={handleDelete}>
                  <FiTrash2 />
                </IconButton>
              )}
            </Box>
          </Stack>
        )}
      </Stack>

      {!isNewClient && <ClientScopesGrid clientId={id} />}
    </Window>
  );
};

export default ClientDetail;
